import './SPActivityCard.scss';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import arrow from '../../../assets/images/arrow.png';
import copletedCheck from '../../../assets/images/copletedCheck.png';
import GetLabels from '../../../pages/SellerProfile/GetLabels';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';


function SPActivityCard({ activityCardData, className = '' }) {
  const {i18n} = useTranslation();

  const {spPageText} = useSelector((state: any) => state.sellerProfile);

  const navigate = useNavigate();
  const handleClick = (link) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/${i18n.language}${link}`);
  };

  return (
    <div className={className}>
      {activityCardData.map((item, i) => {
        const canClick = item?.link !== '' && !item.completed;
        return (
          <Box
            className={`activityCardContainer ${canClick && 'activityCardButton'
              }`}
            key={`${item}-${i}`}
            onClick={canClick ? () => handleClick(item.link) : undefined}
            onKeyDown={
              canClick
                ? (e) => e.key === 'Enter' && handleClick(item.link)
                : undefined
            }
          >
            <div className="cardBody">
              {item.title === 'activityCard' && (
                <img
                  className="icon"
                  src={item.image}
                  alt="Icon"
                  aria-label={item.label}
                />
              )}
              <div className="cardDescription">
                <h3 className="userName">
                  {GetLabels(item.name, spPageText)}
                </h3>
                <p className="userDescription">
                  {GetLabels(item.description, spPageText)}
                </p>
              </div>
            </div>
            {item.completed ? (
              <div className="completedCheck">
                <img
                  className="cardIcon"
                  src={copletedCheck}
                  alt="Competed Check Icon"
                  aria-label="Completed Check Icon"
                />
              </div>
            ) : (
              <div className="arrow"
                role="button"
                tabIndex={0}
                aria-label={GetLabels(item.name, spPageText)}
              >
                <img
                  className="cardIcon"
                  src={arrow}
                  alt="Arrow Icon"
                  aria-label="Arrow Icon"
                />
              </div>
            )}
          </Box>
        );
      })}
    </div>
  );
}

export default SPActivityCard;
